import { defineMetabaseTheme, type MetabaseTheme } from '@metabase/embedding-sdk-react';
import { ADALONG_COLORS } from '@src/styles';

export const metabaseTheme: MetabaseTheme = defineMetabaseTheme({
    preset: 'dark',
    components: {
        dashboard: {
            // Remove only the SDK dashboard shell. Keep the card surface dark;
            // the card visualizations themselves remain configured in Metabase.
            backgroundColor: 'transparent',
            card: {
                backgroundColor: ADALONG_COLORS.DARK_BLACK,
            },
        },
        table: {
            // Match the dashboard card surface instead of the dark preset's
            // blue-tinted default table cells.
            stickyBackgroundColor: ADALONG_COLORS.DARK_BLACK,
            cell: {
                backgroundColor: ADALONG_COLORS.DARK_BLACK,
            },
        },
    },
});
